import TableFormattingUtilities from 'helpers/TableFormattingUtilities';
import React from 'react';

export default class FlagAndAddressComponent extends React.Component<{
  flag: string;
  address: string;
  shortFormatWithTooltip?: number;
}> {
  render() {
    const { flag, address } = this.props;
    const fmt = (text: string) =>
      this.props.shortFormatWithTooltip != null
        ? TableFormattingUtilities.cellWithTooltip(text, this.props.shortFormatWithTooltip)
        : text;
    try {
      return (
        <>
          <img
            alt={flag}
            className={'mr-1 flag-component'}
            src={require(`../../assets/images/flag-icons/svg/${flag.toLowerCase()}.svg`)}
          />
            <span>{fmt(address)}</span>
        </>
      );
    } catch (error) {
      return <span>{flag}</span>;
    }
  }
}
